"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var RippleButton_1 = __importDefault(require("@seaweb/coral/components/RippleButton/RippleButton"));
var Tooltip_1 = __importDefault(require("@seaweb/coral/components/Tooltip/Tooltip"));
var ThemeProvider_1 = require("@seaweb/coral/components/ThemeProvider");
var color_1 = require("@seaweb/coral/utils/color");
var forwardAs_1 = __importDefault(require("@seaweb/coral/hoc/forwardAs"));
var WrappedRippleButton = forwardAs_1.default(RippleButton_1.default);
var StyledRippleButton = styled_1.default(WrappedRippleButton)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var _b = _a.theme, spacing = _b.spacing, colors = _b.colors, disabled = _a.disabled, color = _a.color;
    var size = spacing.factor * 8;
    var bg = color_1.alp(colors.fade, 0.5);
    return styled_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n      color: ", ";\n\n      ", "\n    "], ["\n      width: ", "px;\n      height: ", "px;\n      color: ", ";\n\n      ",
        "\n    "])), size, size, color_1.alp(color_1.des(color, 35), 0.4), disabled
        ? styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            opacity: 0.3;\n          "], ["\n            opacity: 0.3;\n          "]))) : styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            &[data-focus-visible-added] {\n              background-color: ", ";\n            }\n\n            &[data-coral-hover],\n            &:hover {\n              box-shadow: 0 0 0 2px ", ";\n              background-color: ", ";\n              color: ", ";\n            }\n\n            &[data-coral-pressed] {\n              color: ", ";\n            }\n          "], ["\n            &[data-focus-visible-added] {\n              background-color: ", ";\n            }\n\n            &[data-coral-hover],\n            &:hover {\n              box-shadow: 0 0 0 2px ", ";\n              background-color: ", ";\n              color: ", ";\n            }\n\n            &[data-coral-pressed] {\n              color: ", ";\n            }\n          "])), bg, bg, bg, color, color_1.drk(color, 10)));
});
var IconButton = react_1.forwardRef(function IconButton(_a, ref) {
    var as = _a.as, tooltip = _a.tooltip, tooltipProps = _a.tooltipProps, children = _a.children, _b = _a.radius, radius = _b === void 0 ? '50%' : _b, _c = _a.colorType, colorType = _c === void 0 ? ThemeProvider_1.ColorTypes.Primary : _c, c = _a.color, props = __rest(_a, ["as", "tooltip", "tooltipProps", "children", "radius", "colorType", "color"]);
    var color = ThemeProvider_1.useColor(c, colorType);
    var button = (react_1.default.createElement(StyledRippleButton, __assign({ _as: as, ref: ref, radius: radius, color: color }, props), children));
    if (!tooltip)
        return button;
    return (react_1.default.createElement(Tooltip_1.default, __assign({}, tooltipProps, { title: tooltip }), button));
});
exports.default = react_1.memo(IconButton);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
